import version from '../version';
import generateName from './generateName';
import roundValue from './roundValue';
import patternWatermark from './patternWatermark';

var i, j;

const generateDownloadMetaText = (state, options) => {
  var text = "";
  if(!options) options = {};

  if(options.watermark){
    // eslint-disable-next-line

    if(options.team){
      if(options.team.signature){
        var sig_lines = options.team.signature.split(/[\r\n]/);
        for(var i in sig_lines){
          text += '; ' + sig_lines[i] + '\r\n';
        }

      } else {
        text += patternWatermark;
      }

      text += '\r\n';
      text += '; Exported by ' + options.user.display_name + ' <' + options.user.email + '> for ' + options.team.display_name + '.\r\n';
    } else {

      text += patternWatermark;

      text += '\r\n';
      text += '; Created by ' + options.user.display_name + ' <' + options.user.email + '>.\r\n';
    }

    text += '; Made with Pattycake v' + version + '\r\n';
    text += '; Exported ' + new Date().toLocaleString() + ' optimized for ' + (state.format === 'REVIT' ? 'AutoDesk Revit' : 'AutoCAD');
    if(state.calculator) text += ' using pattycake.io\'s templates.';
    text += '\r\n';
    text += '\r\n';



    if(options.includeData){
      if(state.lineSegments && state.mode === 'drawing'){
        text += '; PATTYCAKE_DRAWING_CANVAS_SETTINGS=' +  window.btoa(JSON.stringify(state.jdiSettings)) + '\r\n';
        // text += '; PATTYCAKE_DRAWING_CANVAS_WIDTH=' + state.width + '\r\n';
        // text += '; PATTYCAKE_DRAWING_CANVAS_HEIGHT=' + state.height + '\r\n';

        let datastring = window.btoa(JSON.stringify(state.lineSegments));
        for(let i = 0; i < datastring.length; i += 4000){
          text += '; PATTYCAKE_DRAWING_CANVAS_LINESEGMENTS=' + datastring.substring(i, i + 4000) + '\r\n';
        }
        text += '\r\n';
      }

      if(state.mode === 'template'){
        text += '; PATTYCAKE_TEMPLATE=' + window.btoa(state.calculator) + '\r\n';
        text += '; PATTYCAKE_TEMPLATE_VARIABLES=' + window.btoa(JSON.stringify(state.variables)) + '\r\n';
        text += '\r\n';
      }
    }
    

    if(options.includeErrors){
      var error_count = 0;
      for(var i in state.rows){
        if(state.rows[i].invisible && !options.includeHidden) continue;
        if(state.rows[i].errors){
          error_count += state.rows[i].errors.length;
        }
      }
      if(error_count){
        text += ';/////////////////////////////////////////////////////////////////////////////////////////////////////\r\n';
        text += '; THIS .PAT FILE CONTAINS THE FOLLOWING ERRORS AND MAY NOT IMPORT PROPERLY:\r\n';
        text += ';\r\n';

        var lines_so_far = text.split('\r\n').length;

        // total_errors
        lines_so_far += error_count;

        // revit meta data
        if(state.format === 'REVIT') lines_so_far += 4;

        // title, description, header_row
        if(state.format === 'REVIT') lines_so_far += 3;

        // title, description, breaker, header_row
        if(state.format === 'AUTOCAD') lines_so_far += 4;

        // line break after errors
        lines_so_far += 2

        var counter = 0;
        for(var i in state.rows){
          if(state.rows[i].invisible && !options.includeHidden) continue;
          if(state.rows[i].errors){
            for(var j in state.rows[i].errors){
              text += "; Line #" + (counter + 1) + " (on line " + (counter + lines_so_far) + ' of this file):\t' + state.rows[i].errors[j] + '\r\n';
            }
          }
          counter++;
        }
        text += ';/////////////////////////////////////////////////////////////////////////////////////////////////////\r\n';
        text += '\r\n';
      }
    }
  }

  return text;
}

export default generateDownloadMetaText;


// WEBPACK FOOTER //
// ./src/pattern_utilities/generateDownloadMetaText.js